import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "../Styles/Preloader.css";

const svgVariants = {
  hidden: { rotate: -10 },
  visible: {
    rotate: 0,
    transition: { duration: 1.5 },
  },
};

const pathVariants = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
};

const Preloader = () => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 0, display: "none" }}
      // initial={{ x: 0 }}
      // animate={{ x: -500 }}
      transition={{ duration: 1, delay: 2 }}
      className="Preloader"
    >
      <div className="logo-container relative w-[100vw] flex justify-center">
        <motion.svg
          width="366"
          height="418"
          viewBox="0 0 366 418"
          variants={svgVariants}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <motion.path
            d="M178.679 121.994L178.685 122.023L178.692 122.051C181.128 131.947 181.212 142.33 179.089 152.333C176.878 161.707 172.385 171.778 166.13 179.769C154.661 192.793 140.367 201.085 122.993 205.05L121.049 205.494V207.487V385.35C121.049 393.496 118.517 401.129 112.962 406.682C107.33 412.312 99.6462 415.5 90.8846 415.5C83.6547 415.5 75.9695 412.355 70.2851 406.682C64.5263 400.925 60.7203 393.206 60.7203 385.35V207.487V205.435L58.7071 205.035C42.8353 201.884 27.8337 193.054 17.0448 180.037C10.6681 172.014 6.21774 162.658 4.03584 152.595C1.85129 142.519 1.99905 132.131 4.46722 122.135L4.4744 122.106L4.48088 122.077L29.1482 10.7799L29.1486 10.7779C29.7091 8.23883 31.1936 5.99417 33.3146 4.47709L33.318 4.47463C35.4279 2.96014 38.0362 2.27813 40.6261 2.56363L40.6297 2.56402C43.2238 2.84614 45.6287 4.08229 47.3734 6.03494L47.3736 6.03525C49.1146 7.98312 50.0663 10.5071 50.0531 13.124H50.053V13.1367V130.678V133.178H52.553H66.7375H68.9655L69.221 130.964L83.1749 10.1014C83.1752 10.0988 83.1756 10.0962 83.1759 10.0935C83.43 8.02953 84.4253 6.13628 85.9974 4.76156L86.0163 4.74506L86.0348 4.72819C87.5897 3.31254 89.6184 2.60928 90.8846 2.60928C93.8001 2.60928 95.7791 3.43055 97.2044 4.72819L97.2229 4.74506L97.2418 4.76156C97.9007 5.33775 98.3702 6.05508 98.8148 7.03698C99.1146 7.69911 99.3337 8.29948 99.5893 9.00013C99.7431 9.42168 99.9102 9.87952 100.116 10.4089L114.043 130.965L114.298 133.178H116.526H130.082H132.582V130.678V13.1367C132.582 10.8565 133.878 8.50926 135.29 6.05404C137.789 4.01704 140.181 2.85983 142.618 2.56224C145.023 2.30078 146.986 2.86859 150.038 4.57819C152.077 6.09483 153.505 8.32083 154.102 10.8737C154.103 10.8781 154.104 10.8824 154.105 10.8867L178.679 121.994ZM303.171 287.399V284.899H300.671H286.952C280.434 284.899 273.902 283.581 267.83 281.094C261.831 278.521 256.312 274.865 251.655 270.213C247.118 265.6 243.448 260.106 240.202 253.967C238.408 247.824 237.189 241.298 237.189 234.832L237.189 234.83L237.108 141.972C237.837 112.321 246.763 83.3358 263.38 58.8468L263.381 58.8452C280.005 34.3042 303.535 15.3128 331.078 4.30732L331.161 4.27443L331.241 4.2358C333.967 2.91537 338.446 2.33465 342.378 2.7574L342.645 0.27172L342.378 2.75741C346.222 3.17058 349.913 4.51675 353.08 6.67066C356.27 8.84066 358.921 11.7486 360.679 15.1303L360.689 15.15L360.699 15.1696C362.143 17.8307 362.59 20.6785 363.126 24.0929C363.243 24.8368 363.364 25.6077 363.5 26.4094V385.35C363.5 393.342 360.331 401.031 354.678 406.682C349.025 412.332 341.333 415.5 333.336 415.5C325.339 415.5 317.646 412.332 311.993 406.682C306.34 401.031 303.171 393.342 303.171 385.35V287.399Z"
            stroke="white"
            initial={{ opacity: 0, pathLength: 0 }}
            animate={{ opacity: 1, pathLength: 1}}
            transition={{duration: 2}}
            stroke-width="5"
          />
        </motion.svg>
      </div>
    </motion.div>
  );
};

export default Preloader;
